import { render } from "./ShishiJiedian.vue?vue&type=template&id=5ae01282&scoped=true"
import script from "./ShishiJiedian.vue?vue&type=script&lang=js"
export * from "./ShishiJiedian.vue?vue&type=script&lang=js"

import "./ShishiJiedian.vue?vue&type=style&index=0&id=5ae01282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae01282"]])

export default __exports__